
<form [formGroup]="signIn" (ngSubmit)="Login($event)">
      <mat-card-content class="d-flex flex-column">        
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ 'loginForm.txtEmail' | translate }}</mat-label>
          <input matInput placeholder="{{ 'loginForm.txtEmail' | translate }}" (focus)="focusEvent()" formControlName="user" required>
          @if(signIn.get('user')?.hasError('invalid')){
            <mat-error>{{ 'loginForm.txtError' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-100 mobile-style" appearance="outline">
          <mat-label>{{ 'loginForm.txtPass' | translate }}</mat-label>
          <input matInput [type]="hide() ? 'password' : 'text'" formControlName="password" (focus)="focusEvent()" placeholder="{{ 'loginForm.txtPass' | translate }}" required>
          <button mat-icon-button matSuffix class="button-icon" (click)="clickEvent($event)" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide()">
            <span class="material-symbols-outlined {{hide() ? 'visibility_off' : 'visibility'}}"></span>
          </button>
          @if(signIn.get('password')?.hasError('invalid')){
            <mat-error>{{ 'loginForm.txtError' | translate }}</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <div class="error-sign-in hide">{{ 'loginForm.txtError' | translate }}</div>
      <mat-card-actions>
        <app-recover/>
        @if(!isSignInClick){
          <button type="submit" class="btn-link on-boarding-home" [disabled]="!signIn.valid" queryParamsHandling="preserve">
            <span>{{ 'buttons.txtEnterBtn' | translate }}</span>
          </button>
        }@else{
          <button type="button" class="btn-link on-boarding-home">
            <span>{{ 'buttons.txtSignInLoad' | translate }}</span>
            <span class="material-symbols-outlined">progress_activity</span>
          </button>
        }
        
      </mat-card-actions>
    </form>
